import React, { useState, useCallback, useContext, FC } from 'react';
import { Box } from '@mui/material';
import { CommonDataContext } from 'contexts/CommonDataContext';

import { Day } from './day';
import { Week } from './week';
import { Month } from './month';
import { Listing } from './table';
import { EventCard } from './card';
import { useEventIdParam } from '../hooks';
import { CalendarPanel } from './CalendarPanel';
import { CalendarLayout } from './CalendarLayout';
import { CalendarView, CalendarViewComponentProps } from '../types';

export const CalendarContainer = () => {
  const { eventId } = useEventIdParam();
  const { isSuperAdmin } = useContext(CommonDataContext);

  const [view, setView] = useState<CalendarView>(CalendarView.Month);
  const [date, setDate] = useState<Date>(new Date());
  const [userProfileId, setUserProfileId] = useState<string | null>(null);

  const handleNavigate = useCallback((nextDate: Date) => setDate(nextDate), []);

  const renderNestedSectionByMode: Record<CalendarView, FC<CalendarViewComponentProps>> = {
    [CalendarView.Day]: Day,
    [CalendarView.Week]: Week,
    [CalendarView.Month]: Month,
    [CalendarView.Table]: Listing,
  };

  const ViewComponent = renderNestedSectionByMode[view];

  return (
    <>
      {eventId && <EventCard id={eventId} />}

      <CalendarLayout>
        <CalendarPanel
          view={view}
          setView={setView}
          showUserSelect={isSuperAdmin}
          userProfileId={userProfileId}
          onUserProfileChange={setUserProfileId}
        />

        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <ViewComponent date={date} onNavigate={handleNavigate} userProfileId={isSuperAdmin ? userProfileId : null} />
        </Box>
      </CalendarLayout>
    </>
  );
};
